// 机器检测结果生成的静态访问清单；后续人工核查仅做增量修复。
const routeAccess = [
  { path: '/', access: 'public', reviewRequired: false },
  { path: '/privacyPolicy', access: 'public', reviewRequired: false },
  { path: '/home', access: 'inherit', reviewRequired: true },
  { path: '/home/index', access: 'employee', reviewRequired: false },
  { path: '/home/trajectory', access: 'employee', reviewRequired: false },
  { path: '/home/user', access: 'employee', reviewRequired: false },
  { path: '/home/userinfo', access: 'employee', reviewRequired: false },
  { path: '/home/certificate', access: 'employee', reviewRequired: false },
  { path: '/home/myIncome', access: 'employee', reviewRequired: false },
  { path: '/home/auth', access: 'employee', reviewRequired: false },
  { path: '/home/personConRate', access: 'employee', reviewRequired: false },
  { path: '/teamConRate', access: 'public', reviewRequired: false },
  { path: '/getPolicyList', access: 'employee', reviewRequired: false },
  { path: '/getPolicyDetails', access: 'employee', reviewRequired: false },
  { path: '/home/message', access: 'employee', reviewRequired: false },
  { path: '/home/detail', access: 'employee', reviewRequired: false },
  { path: '/home/MsgHome', access: 'employee', reviewRequired: false },
  { path: '/home/msgList', access: 'employee', reviewRequired: false },
  { path: '/renewal', access: 'inherit', reviewRequired: true },
  { path: '/renewal/orphanAcceptance', access: 'employee', reviewRequired: false },
  { path: '/404', access: 'public', reviewRequired: false }
]

module.exports = routeAccess



// WEBPACK FOOTER //
// ./src/router/access.js